import { Badge } from "@chakra-ui/react";
import { DeviceOrientationEventiOS } from "@/types/data";

interface IDeviceOrientationAlert {
  orientation: DeviceOrientationEventiOS | null;
}

const MAX_ANGLE = 25;

function DeviceOrientationAlert({ orientation }: IDeviceOrientationAlert) {
  const outOfBetaRange = orientation?.beta
    ? orientation?.beta > MAX_ANGLE || orientation?.beta < -MAX_ANGLE
    : false;
  const outOfGammaRange = orientation?.gamma
    ? orientation?.gamma > MAX_ANGLE || orientation?.gamma < -MAX_ANGLE
    : false;

  if (outOfBetaRange || outOfGammaRange) {
    return (
      <Badge variant="solid" colorPalette="red" size="sm">
        Hold phone parallel to ground
      </Badge>
    );
  }
  return null;
}

export default DeviceOrientationAlert;
